// @ts-check
import { roundToDecimal } from './decimals'
import { isNumber } from './is'
import { cleanUpRound } from './numbers'
const KG_TO_LBS = 0.45359237

const lbsToKg = lbs => cleanUpRound(KG_TO_LBS * lbs)
const kgToLbs = kg => cleanUpRound(kg / KG_TO_LBS)

/**
 * This is the the function we always want to use when storing a weight to the case data.
 *
 * If it is given in inches we'll store it as kg with 2 decimal places of
 * precision to ensure that it is stored with enough precision to be converted
 * back to the same one decimal of precision value if we are going back to lbs.
 *
 * @param {number} lbs
 * @returns {number | null}
 */
export const convertLbsToKgForStorage = lbs =>
  isNumber(lbs) ? roundToDecimal(lbsToKg(lbs), 2) : null

/**
 * @param {number} kgs
 * @param {WeightUnit} targetWeightUnit
 * @returns {number | null}
 */
export const convertStoredKgForDisplay = (kgs, targetWeightUnit) => {
  if (!isNumber(kgs)) {
    return null
  }
  return roundToDecimal(targetWeightUnit === 'lb' ? kgToLbs(kgs) : kgs, 1)
}
